import { Injectable } from '@angular/core';
import { catchError, map, retry } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { UserBegleitIndikator } from '../data/user/user-begleit-indikator.model';
import { UserIndikatorenUeberkategorieFilter } from '../data/user/user-indikatoren-ueberkategorie-filter.model';
import { UeberkategorieFilter } from '../data/user/ueberkategorie-filter.model';
import { ConstantsWebservice } from '../immutable/constants-webservice';
import { AppFile, GlobalApiService, GlobalConstantsWebservice, GlobalFunctions, GlobalSessionData } from 'globales-projekt-angular';
import { UserPdfSynopse } from '../data/user/user-pdf-synopse.model';
import { Indikator } from '../data/indikator.model';
import { Synopse } from '../data/ws/synopse.model'; 

@Injectable({
  providedIn: 'root',
})
export class ApiService extends GlobalApiService {
  getIndikatorRichtungen(): Observable<Indikator[]> {
    let serviceUrl: string =
      GlobalSessionData.baseUrl +
      ConstantsWebservice.GET_INDIKATOREN_RICHTUNGEN;
    return this.http
      .get<Indikator[]>(serviceUrl)
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }

  postUeberkategorieFilterAnzahl(
    body: UserIndikatorenUeberkategorieFilter
  ): Observable<UeberkategorieFilter[]> {
    let serviceUrl: string =
      GlobalSessionData.baseUrl +
      ConstantsWebservice.POST_INDIKATOREN_UEBERKATEGORIE_FILTERANZAHL;
    return this.http
      .post<UeberkategorieFilter[]>(serviceUrl, body)
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }

  postIndikatorenErgebnisseListe(
    body: UserIndikatorenUeberkategorieFilter
  ): Observable<Synopse[]> {
    let serviceUrl: string =
      GlobalSessionData.baseUrl +
      ConstantsWebservice.POST_INDIKATOREN_ERGEBNISSE_LISTE;
    return this.http
      .post<Synopse[]>(serviceUrl, body)
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }

  postBegleitIndikatorErgebnisseListe(
    body: UserBegleitIndikator
  ): Observable<Synopse[]> {
    let serviceUrl: string =
      GlobalSessionData.baseUrl +
      ConstantsWebservice.POST_BEGLEITINDIKATOREN_LISTE;
    return this.http
      .post<Synopse[]>(serviceUrl, body)
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }

  postIndikatorenAnzahl(
    body: UserIndikatorenUeberkategorieFilter
  ): Observable<number> {
    let serviceUrl: string =
      GlobalSessionData.baseUrl +
      ConstantsWebservice.POST_INDIKATOREN_ANZAHL;
    return this.http
      .post<number>(serviceUrl, body)
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  } 

  // Todo die api mit dem globalen Projekt abgleichen.
  postPdfSynopse(body: UserPdfSynopse): Observable<Blob> {
    let serviceUrl: string =
      GlobalSessionData.baseUrl + ConstantsWebservice.POST_PDF_SYNOPSE;
    return this.http
      .post<Blob>(serviceUrl, body, { responseType: 'blob' as 'json' })
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }


// Work-Around TODO: Auf das aktuelle umstellen und das alte löschen
 

   getWorkAround(): Observable<AppFile[]> {
    const serviceUrl = GlobalSessionData.baseUrl + "/file-size-app-documents";

    return this.http
      .get<AppFile[]>(serviceUrl)
      .pipe(map((appFiles) => appFiles.map((appFile) => Object.assign(new AppFile(), appFile))),
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE), catchError(GlobalFunctions.handleError));
  }
  
}
